/**
 * Created by lu on 2018/5/4.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent:nb.Model
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/tab/TabListItem.js
// module id = 43
// module chunks = 0 1 2 3 7 8 9 10 11 12 14 16 18 19 20 25 26 28 29 30